/* eslint-disable */
// import Vue from 'vue'
import { createApp } from 'vue';
import App from './App.vue'
import router from './router'
import store from './store'
import loader from "vue3-ui-preloader";
import VueGtag from 'vue-gtag';

import "vue3-ui-preloader/dist/loader.css"

const app = createApp(App);

app.use(VueGtag, {
  config: { 
    id: "G-2BQE30Q4VM",
    params: {
      send_page_view: false
    }
  }
}, router);

// Vue.config.productionTip = false
// Vue.use(loader)

// new Vue({
//   router,
//   store,
//   loader:loader,
//   render: h => h(App)
// }).$mount('#app')

app.config.productionTip = false
app.use(router);
app.use(store);
app.component('loader', loader);

app.mount('#app')
